import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { Button } from 'antd';


class Unauthorized extends Component {

  // NOTE: if you extend propTypes directly in child component class, you will get a react warning.  use _propTypes alias instead
  static propTypes = {
    title: PropTypes.any,
    message: PropTypes.any,
  };

  static defaultProps = {
    title: 'Please sign in to continue!',  // 'You must be logged in to view this page!',
    message: null,
  };


  render() {
    return (
      <div className="logged-out-unauthorized">
        <div className="login-prompt modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header no-border">
              <h5 className="modal-title">{this.props.title}</h5>
            </div>
            <div className="modal-body center">
              {this.props.message}
              <NavLink to="/login">
                <Button type="primary" size="large">Sign in</Button>
              </NavLink>
            </div>
            <div className="modal-footer">
            </div>
          </div>
        </div>
      </div>
    );
  }
}


export default Unauthorized;
